"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.n = (module)=>{
        var getter = module && module.__esModule ? ()=>module['default'] : ()=>module;
        __webpack_require__.d(getter, {
            a: getter
        });
        return getter;
    };
})();
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    defaultGatewayConfig: ()=>defaultGatewayConfig,
    convertGatewayConfig: ()=>convertGatewayConfig,
    getGatewayTccProxy: ()=>getGatewayTccProxy,
    getGatewayConfigV2: ()=>getGatewayConfigV2
});
const domain_id_config_js_namespaceObject = require("../domain-id/domain-id.config.js");
const core_lib_namespaceObject = require("@bytecloud/core-lib");
const async_jwt_service_js_namespaceObject = require("../jwt/async-jwt.service.js");
const cloud_api_config_namespaceObject = require("@bytecloud/cloud-api-config");
const query_config_js_namespaceObject = require("../utils/query.config.js");
const row_js_namespaceObject = require("../aegis-api-config/row.js");
const mapValues_namespaceObject = require("lodash/mapValues");
var mapValues_default = /*#__PURE__*/ __webpack_require__.n(mapValues_namespaceObject);
const once_namespaceObject = require("lodash/once");
var once_default = /*#__PURE__*/ __webpack_require__.n(once_namespaceObject);
function _define_property(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if ("function" == typeof Object.getOwnPropertySymbols) ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function gateway_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = null != source ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else gateway_config_ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}
const getOrigin = (domainID)=>`https://${domain_id_config_js_namespaceObject.domainIDHostnameMap[domainID]}`;
const defaultGatewayConfig = {
    gatewayItems: {
        sandbox: {
            origin: getOrigin('sandbox')
        },
        boe: {
            origin: getOrigin('boe')
        },
        online: {
            origin: getOrigin('online')
        },
        hl: {
            origin: getOrigin('hl')
        },
        lq: {
            origin: getOrigin('lq')
        },
        pd: {
            origin: getOrigin('pd')
        },
        us: {
            origin: getOrigin('us')
        },
        i18n: {
            origin: getOrigin('ttp-row')
        },
        'i18n-sg': {
            origin: getOrigin('ttp-row-sg')
        },
        'i18n-bd': {
            origin: getOrigin('i18n-bd')
        },
        'i18n-bd-de': {
            origin: getOrigin('i18n-bd-de')
        },
        'i18n-maliva': {
            forceWithJwt: true,
            origin: 'https://bc-maliva-gw.tiktok-row.net'
        },
        'i18n-sgcentral': {
            forceWithJwt: true,
            origin: 'https://bc-sg-gw.tiktok-row.net'
        },
        'boe-i18n': {
            origin: row_js_namespaceObject.rowGatewayOriginConfig.boei18n
        },
        'ttp-us': {
            origin: getOrigin('ttp-us')
        },
        'ttp-us-limited': {
            origin: 'https://cloud.tiktok-us.net'
        },
        sinf: {
            origin: getOrigin('sinf')
        },
        sinfonlinea: {
            origin: getOrigin('sinfonlinea')
        },
        'sinf-boe': {
            origin: getOrigin('sinf-boe')
        },
        sinfi18n: {
            origin: getOrigin('sinfi18n')
        },
        volcgroup: {
            origin: getOrigin('volcgroup')
        },
        'volcgroup-boe': {
            origin: getOrigin('volcgroup-boe')
        },
        'ttp-row': {
            origin: getOrigin('ttp-row')
        },
        'ttp-row-sg': {
            origin: getOrigin('ttp-row-sg')
        },
        'ttp-eu': {
            origin: 'https://bc-iedt-gw.tiktok-eu.net'
        },
        'ttp-eu-de': {
            origin: 'https://bc-dedt-gw.tiktok-eu.net'
        },
        'ttp-eu-gcp': {
            origin: 'https://bc-gcp-gw.tiktok-eu.net'
        },
        'ttp-eu-useast2b': {
            origin: 'https://bc-useast2b-gw.tiktok-eu.net'
        },
        currentOrigin: {
            origin: ''
        }
    },
    domainIDToGatewayKey: {
        local: 'sandbox',
        boe: 'boe',
        sandbox: 'sandbox',
        online: 'online',
        hl: 'hl',
        lq: 'lq',
        pd: 'pd',
        us: 'us',
        i18n: 'i18n',
        'i18n-sg': 'i18n-sg',
        'boe-i18n': 'boe-i18n',
        'ttp-us': 'ttp-us',
        'ttp-us-limited': 'ttp-us-limited',
        sinf: 'sinf',
        'sinf-boe': 'sinf-boe',
        sinfi18n: 'sinfi18n',
        sinfonlinea: 'sinfonlinea',
        volcgroup: 'volcgroup',
        'volcgroup-boe': 'volcgroup-boe',
        tx: 'online',
        'tx-tt': 'online',
        xfl: 'online',
        'sinf-xfl': 'online',
        'sinf-xfl-boe': 'online',
        'ttp-row': 'ttp-row',
        'ttp-row-sg': 'ttp-row-sg',
        'ttp-eu': 'ttp-eu',
        'ttp-eu-de': 'ttp-eu-de',
        'i18n-bd': 'i18n-bd',
        'i18n-bd-de': 'i18n-bd-de'
    },
    gatewayKeyToDomainID: {
        boe: 'boe',
        sandbox: 'sandbox',
        online: 'online',
        hl: 'hl',
        lq: 'lq',
        pd: 'pd',
        us: 'us',
        i18n: 'i18n',
        'i18n-sg': 'i18n-sg',
        'i18n-maliva': 'i18n',
        'i18n-sgcentral': 'i18n',
        'ttp-eu-gcp': 'ttp-eu',
        'boe-i18n': 'boe-i18n',
        'ttp-us': 'ttp-us',
        'ttp-us-limited': 'ttp-us-limited',
        sinf: 'sinf',
        'sinf-boe': 'sinf-boe',
        sinfi18n: 'sinfi18n',
        sinfonlinea: 'sinfonlinea',
        volcgroup: 'volcgroup',
        'volcgroup-boe': 'volcgroup-boe',
        'ttp-row': 'ttp-row',
        'ttp-row-sg': 'ttp-row-sg',
        'ttp-eu': 'ttp-eu',
        'ttp-eu-de': 'ttp-eu-de',
        'i18n-bd': 'i18n-bd',
        'i18n-bd-de': 'i18n-bd-de',
        'ttp-eu-useast2b': 'ttp-eu'
    },
    defaultRewriteRules: [
        {
            match: '/api/v1/iam/',
            matchType: 'string',
            rewriteGatewayKey: {
                boe: 'online',
                'boe-i18n': 'online',
                'sinf-boe': 'sinf'
            }
        },
        {
            match: '/api/v1/cloud/api/event_bridge/',
            matchType: 'string',
            rewriteGatewayKey: {
                'sinf-boe': 'sinf',
                'boe-i18n': 'online'
            },
            rewriteURL: {
                searchValue: '/api/v1/cloud',
                replaceValue: {
                    'ttp-us-limited': cloud_api_config_namespaceObject.allCloudApiConfigs["ttp-us-limited"].page
                }
            }
        },
        {
            match: '^/api/v1/cloud/api/(v1/)?bpm_proxy',
            matchType: 'regexp',
            rewriteGatewayKey: {
                boe: 'online',
                'sinf-boe': 'sinf',
                'boe-i18n': 'online'
            },
            rewriteURL: {
                searchValue: '/api/v1/cloud',
                replaceValue: {
                    'ttp-us-limited': cloud_api_config_namespaceObject.allCloudApiConfigs["ttp-us-limited"].openapi
                }
            }
        },
        {
            match: '^/api/v1/cloud/api/v(1|2|3)/service_manager',
            matchType: 'regexp',
            rewriteGatewayKey: {
                boe: 'online',
                'boe-i18n': 'online',
                i18n: 'online',
                'i18n-sg': 'online',
                'sinf-boe': 'sinf',
                'ttp-row': 'online',
                'ttp-row-sg': 'online',
                us: 'online'
            }
        },
        {
            match: '^/api/v1/cloud/api/(v1/)?oapi/',
            matchType: 'regexp',
            rewriteGatewayKey: {
                boe: 'online',
                'boe-i18n': 'online',
                'sinf-boe': 'sinf',
                sinfi18n: 'sinf',
                'ttp-row': 'online',
                'ttp-row-sg': 'hl',
                i18n: 'online',
                'i18n-sg': 'hl',
                us: 'online'
            },
            rewriteURL: {
                searchValue: '/api/v1/cloud',
                replaceValue: {
                    'ttp-us-limited': cloud_api_config_namespaceObject.allCloudApiConfigs["ttp-us-limited"].page,
                    'ttp-eu': 'https://cloud-openapi-eu.tiktok-eu.net',
                    'ttp-eu-de': 'https://cloud-openapi-eu.tiktok-eu.net'
                }
            }
        },
        {
            match: '/api/v1/cloud/',
            matchType: 'string',
            rewriteGatewayKey: {
                boe: 'online',
                'boe-i18n': 'online',
                'sinf-boe': 'sinf',
                sinfi18n: 'sinf',
                'ttp-row': 'online',
                'ttp-row-sg': 'hl',
                i18n: 'online',
                'i18n-sg': 'hl',
                us: 'online',
                'ttp-eu': 'online',
                'ttp-eu-de': 'hl'
            },
            rewriteURL: {
                searchValue: '/api/v1/cloud',
                replaceValue: {
                    'ttp-us-limited': cloud_api_config_namespaceObject.allCloudApiConfigs["ttp-us-limited"].page
                }
            }
        },
        {
            match: '/api/v1/scm/',
            matchType: 'string',
            rewriteURL: {
                searchValue: '/api/v1/scm',
                replaceValue: {
                    'ttp-eu': row_js_namespaceObject.gatewayRewriteConfig.scm,
                    'ttp-eu-de': row_js_namespaceObject.gatewayRewriteConfig.scmHL,
                    'ttp-us-limited': row_js_namespaceObject.gatewayRewriteConfig.scmRow,
                    'ttp-us': row_js_namespaceObject.gatewayRewriteConfig.scmRow,
                    i18n: row_js_namespaceObject.gatewayRewriteConfig.scm,
                    'i18n-sg': row_js_namespaceObject.gatewayRewriteConfig.scmHL,
                    'i18n-bd': row_js_namespaceObject.gatewayRewriteConfig.scm,
                    'i18n-bd-de': row_js_namespaceObject.gatewayRewriteConfig.scmHL
                }
            }
        },
        {
            match: '/api/v1/tenant/',
            matchType: 'string',
            rewriteGatewayKey: {
                boe: 'online'
            }
        },
        {
            match: '/api/v1/bytetree/',
            matchType: 'string',
            rewriteGatewayKey: {
                boe: 'online',
                'sinf-boe': 'sinf',
                'boe-i18n': 'online'
            },
            rewriteURL: {
                searchValue: '/api/v1/bytetree',
                replaceValue: {
                    'ttp-us-limited': cloud_api_config_namespaceObject.allCloudApiConfigs["ttp-us-limited"].bytetree
                }
            }
        }
    ],
    downgradeConfig: {
        online: false,
        boe: false,
        i18n: false,
        'ttp-row': false,
        'ttp-eu': false,
        'ttp-us-limited': false,
        'ttp-us': false,
        all: false
    }
};
const isHostnameEqual = (hostnameA, hostnameB)=>{
    try {
        const urlObjA = new URL(hostnameA);
        const urlObjB = new URL(hostnameB);
        return urlObjA.hostname === urlObjB.hostname;
    } catch (error) {
        console.error(error);
        return false;
    }
};
const waitAllValues = async (promises)=>{
    const keys = Object.keys(promises);
    const results = await Promise.all(keys.map((key)=>promises[key]));
    return keys.reduce((acc, key, index)=>{
        acc[key] = results[index];
        return acc;
    }, {});
};
const getGatewayTccProxy = once_default()(()=>{
    const isPreview = (0, query_config_js_namespaceObject.checkTccProxyFlag)('preview', 'gateway-config');
    const isTest = (0, query_config_js_namespaceObject.checkTccProxyFlag)('test', 'gateway-config');
    const instance = new core_lib_namespaceObject.TccProxy({
        namespace: 'bytecloud.fe.config',
        key: 'gateway_v2',
        fetchStrategy: 'staleWhileRevalidate',
        isPreview: (0, query_config_js_namespaceObject.checkTccProxyFlag)('preview', 'gateway-config'),
        isTest: (0, query_config_js_namespaceObject.checkTccProxyFlag)('test', 'gateway-config'),
        defaultValue: defaultGatewayConfig,
        hostname: 'undefined' != typeof location ? location.hostname : '',
        validator (value) {
            try {
                return Object.prototype.hasOwnProperty.call(value, 'gatewayItems');
            } catch (error) {
                return false;
            }
        },
        useFallbackHostname: true
    });
    return {
        instance,
        isProd: !isPreview && !isTest
    };
});
const convertGatewayConfig = async (config)=>{
    const result = _object_spread_props(_object_spread({}, config), {
        gatewayItems: await waitAllValues(mapValues_default()(config.gatewayItems, async (remoteItem, gKey)=>{
            const gatewayKey = gKey;
            let useJwt = false;
            let jwtUniqueKey = 'currentOrigin';
            if ('currentOrigin' === gatewayKey) {
                jwtUniqueKey = 'currentOrigin';
                useJwt = false;
            } else try {
                const domainID = config.gatewayKeyToDomainID[gatewayKey];
                const jwtInfo = await async_jwt_service_js_namespaceObject.bytecloudAsyncJwtService.getJwtInfoByDomainID(domainID);
                jwtUniqueKey = jwtInfo.uniqueKey;
                useJwt = !isHostnameEqual(jwtInfo.baseUrl, remoteItem.origin);
            } catch (error) {
                console.info(error);
                jwtUniqueKey = 'currentOrigin';
                useJwt = false;
            }
            return _object_spread_props(_object_spread({}, remoteItem), {
                jwtUniqueKey,
                withJwt: remoteItem.forceWithJwt || useJwt,
                withCredentials: remoteItem.forceWithCredentials || !useJwt
            });
        }))
    });
    return result;
};
const getGatewayConfigV2 = once_default()(async ()=>{
    const { instance: tccProxy } = getGatewayTccProxy();
    const config = await tccProxy.getConfig() || defaultGatewayConfig;
    return convertGatewayConfig(config);
});
exports.convertGatewayConfig = __webpack_exports__.convertGatewayConfig;
exports.defaultGatewayConfig = __webpack_exports__.defaultGatewayConfig;
exports.getGatewayConfigV2 = __webpack_exports__.getGatewayConfigV2;
exports.getGatewayTccProxy = __webpack_exports__.getGatewayTccProxy;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "convertGatewayConfig",
    "defaultGatewayConfig",
    "getGatewayConfigV2",
    "getGatewayTccProxy"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
